import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AddRawMaterialRequest, _RawMaterialRequestCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileInput } from "../../../theme/Component/FileInput";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { FileService } from "../../../../core/services/FileService";


interface Props {
    idProductionOrder: any;
    productionOrderDate: any

}
export const RawMaterialRequestCatalog = ({ idProductionOrder, productionOrderDate }: Props) => {

    const RawMaterialRequestCatalog = useDataBean(_RawMaterialRequestCatalog);
    const UpdateMaterialRequestCatalog = useDataBean(_AddRawMaterialRequest);
    const _documentos = useDataBean(_DocumentFactory);
    const single = Singleton.getInstance();
    const file = new FileService();
    const [docs, setDocs] = useState<any>([]);
    const [doc, setDoc] = useState<any>({});
    const [msgList, setMsgList] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [formato, setFormato] = useState<any>([]);
    const [modalverlink, setModalverlink] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const getLista = () => {

        RawMaterialRequestCatalog.instance.getRawMaterialRequestCatalog(idProductionOrder, productionOrderDate).then(
            // (resp: any) => {
            //     if (resp) {

            //         resp.forEach(element => {
            //             element.DataBeanProperties.URLLink = file.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media);
            //             element.DataBeanProperties.Type = 'pdf';
            //             element.DataBeanProperties.Filename = element.DataBeanProperties.Media;
            //         });
            //         setLista(resp)
            //         setDocs(resp);


            //         setDocuments(resp.DocumentURL);
            //         setMsgList(resp.MsgList);
            //     }
            // }
            (resp) => {
                if (resp) {

                    resp.forEach((element: any) => {
                        if (element) {
                            element.DataBeanProperties.URLLink = file.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media);
                            element.DataBeanProperties.Type = 'pdf';
                            element.DataBeanProperties.Filename = element.DataBeanProperties.Media;
                        } else {
                            element.DataBeanProperties.URLLink = "Sin Adjunto";
                        }
                    });

                    setFormato(resp[0]);
                    setLista(resp);
                }
            }
        )

    }

    const create = () => {
        RawMaterialRequestCatalog.setBean({
            Since: _single.getCurrenDate(),
            IDEmployeeRequest: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        RawMaterialRequestCatalog.deleteItemVoid(RawMaterialRequestCatalog.bean.IDRawMaterialRequest).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const addRawMaterialRequest = () => {

        UpdateMaterialRequestCatalog.instance.addRawMaterialRequest(idProductionOrder, productionOrderDate, UpdateMaterialRequestCatalog.bean.Media, UpdateMaterialRequestCatalog.bean.MediaContext, UpdateMaterialRequestCatalog.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setModal({ ...modal, "view": false });
                    getLista();
                    setLista(resp)
                }
            }
        )

    }


    const head = [
        { title: 'ID', property: 'IDRawMaterialRequest', visible: true },
        { title: 'Orden de Producción', property: 'IDProductionOrder', visible: true },
        { title: 'Fecha Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        // { title: 'Soportes Adjuntos', property: 'URL', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
        { title: 'Solicitante', property: 'EmployeeRequestName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const verDocumentos = () => {

        if (RawMaterialRequestCatalog.bean.IDDocument && RawMaterialRequestCatalog.bean.DocumentDate) {
            _documentos.instance.getPdfAccountantDocument(RawMaterialRequestCatalog.bean.IDDocument, RawMaterialRequestCatalog.bean.Mnemonic, RawMaterialRequestCatalog.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModaldoc({ ...modaldoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Descargar solicitud', icono: 'ri-chat-download-fill', visible: single.canDelete(), evento: () => { setModalverlink({ ...modalverlink, "view": true }) } },
            { titulo: 'Ver Documento de Suministro', icono: 'ri-file-search-fill', visible: single.canDelete(), evento: () => { verDocumentos() } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${RawMaterialRequestCatalog.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar Solicitudes de Materia Prima">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={RawMaterialRequestCatalog.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={addRawMaterialRequest}>
                        <div className="row">

                            <div className="col-md-12">

                                <FileInput
                                    Media={UpdateMaterialRequestCatalog.bean.Media}
                                    MediaContext={UpdateMaterialRequestCatalog.bean.MediaContext}
                                    directory='Template'
                                    label='Archivo Adjunto'

                                    onCreate={(Filemap: any) => { UpdateMaterialRequestCatalog.setBean({ ...UpdateMaterialRequestCatalog.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={UpdateMaterialRequestCatalog.bean.Description} onChange={UpdateMaterialRequestCatalog.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverlink} updateModal={setModalverlink}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    {formato?.DataBeanProperties?.URLLink && (
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <a href={formato.DataBeanProperties?.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <strong>{formato.DataBeanProperties?.Filename}</strong>

                                                        </div>
                                                        <div className="col-md-12">
                                                            <small>{formato.DataBeanProperties?.URLLink}</small>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </>
                    </Modal>
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <div className="row">

                            {/* {msgList?.length > 0 &&
                                <ErrorList lista={msgList} />

                            }
                            {msgList?.length === 0 && documents.length > 0 &&
                                <DocumentViewer key={documents} list={documents} />
                            } */}

                            <DocumentViewer list={docs} IDDocument={RawMaterialRequestCatalog.bean.IDDocument} Since={RawMaterialRequestCatalog.bean.DocumentDate} />
                            {/* <PrintJson json={docs} /> */}
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {RawMaterialRequestCatalog.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}